import React, { FC, useState } from 'react'
import { LocaleCurrency, USD } from 'components/FormatPrice'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import ProductOriginalConnector, {
  ConnectorProps as ProductOriginalProps,
} from '../../../connectors/ProductsOriginal'
import Affirm from './Affirm'
import MAO from './MAO'
import { LinkButton, Row, Price } from '../../styles/products'
import { FOR_SALE } from '../../../helpers/constants'
import classNames from 'classnames'

const OriginalForSale: FC<ProductOriginalProps> = (props) => {
  const [addToCart, updateAddToCart] = useState(false)
  const {
    clickAddToCart,
    clickMakeAnOffer,
    productStatus,
    sku,
    updateDataLayer,
    listPrice,
    promoCode,
  } = props

  if (productStatus !== FOR_SALE) {
    return null
  }

  return (
    <>
      <Row>
        <Price>
          <h4 className='defaultTypographyH4'>
            <LocaleCurrency price={convertFromCentsToDollars(listPrice)} />
            <USD />
          </h4>
        </Price>

        <LinkButton
          addingToCart={addToCart}
          data-button='add-to-cart'
          disabled={addToCart}
          onClick={(ev: React.SyntheticEvent<HTMLButtonElement>) => {
            ev.preventDefault()
            updateAddToCart(true)
            clickAddToCart({ sku, promoCode })
          }}
          title='Add artwork to cart'
        >
          <p
            className={classNames('defaultTypographyCtaLarge', 'defaultTextBold')}
            style={{ color: '#ffffff', margin: 0 }}
          >
            {addToCart ? 'Adding...' : 'Add to Cart'}
          </p>
        </LinkButton>
      </Row>

      <Row>
        <Affirm />

        <span />

        <MAO onClick={clickMakeAnOffer} sku={sku} updateDataLayer={updateDataLayer} />
      </Row>
    </>
  )
}

export default ProductOriginalConnector(OriginalForSale)
